import React from 'react'

export function VolcanicArena({ className = '' }) {
  return (
    <svg
      viewBox="0 0 1200 600"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="volcanoSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2d0a0a" />
          <stop offset="60%" stopColor="#5c1010" />
          <stop offset="100%" stopColor="#d32f2f" />
        </linearGradient>
        <linearGradient id="lavaGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffeb3b" />
          <stop offset="20%" stopColor="#ff9800" />
          <stop offset="100%" stopColor="#d32f2f" />
        </linearGradient>
        <linearGradient id="rockGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#424242" />
          <stop offset="100%" stopColor="#1a1a1a" />
        </linearGradient>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* Background */}
      <rect width="1200" height="600" fill="url(#volcanoSky)" />

      {/* Distant Volcanoes */}
      <path d="M-100 600 L150 250 L400 600 Z" fill="#1a0505" />
      <path d="M800 600 L1050 200 L1300 600 Z" fill="#1a0505" />

      {/* Eruption Glow */}
      <circle cx="150" cy="250" r="100" fill="#ff5722" opacity="0.3" filter="url(#glow)" />
      <circle cx="1050" cy="200" r="120" fill="#ff5722" opacity="0.3" filter="url(#glow)" />

      {/* Lava Sea */}
      <path d="M0 550 Q 150 530 300 550 T 600 550 T 900 550 T 1200 550 L 1200 650 L 0 650 Z" fill="url(#lavaGrad)" filter="url(#glow)" />

      {/* Embers */}
      <g fill="#ffeb3b" filter="url(#glow)">
        <circle cx="300" cy="500" r="4" />
        <circle cx="450" cy="550" r="3" />
        <circle cx="600" cy="480" r="5" />
        <circle cx="800" cy="520" r="3" />
        <circle cx="950" cy="560" r="4" />
      </g>

      {/* Main Platform */}
      <g transform="translate(250, 400)">
        <path d="M40 0 L660 0 L700 40 L650 150 L50 150 L0 40 Z" fill="url(#rockGrad)" stroke="#ff5722" strokeWidth="2" />
        <path d="M200 0 L220 40 L180 80 M500 0 L480 50 L520 90" stroke="#ff9800" strokeWidth="3" fill="none" filter="url(#glow)" />
      </g>

      {/* Left Floating Platform */}
      <g transform="translate(150, 250)">
        <path d="M20 0 L230 0 L250 20 L200 50 L50 50 L0 20 Z" fill="url(#rockGrad)" stroke="#ff5722" strokeWidth="1" />
      </g>

      {/* Right Floating Platform */}
      <g transform="translate(800, 250)">
        <path d="M20 0 L230 0 L250 20 L200 50 L50 50 L0 20 Z" fill="url(#rockGrad)" stroke="#ff5722" strokeWidth="1" />
      </g>

      {/* Top Center Floating Platform */}
      <g transform="translate(475, 120)">
        <path d="M20 0 L230 0 L250 20 L200 50 L50 50 L0 20 Z" fill="url(#rockGrad)" stroke="#ff5722" strokeWidth="1" />
      </g>
    </svg>
  )
}
